module.exports = __webpack_public_path__ + "img/ZFB_logo.b8da2cbe.png";